import { z } from 'zod';

export const AddToCartSchema = z.object({
    purchase_id: z.string(),
    quantity: z.coerce.number(),
    type: z.string(),
    price: z.coerce.number(),
    discount_type: z.string().nullable().optional(),
    discount_value: z.number().default(0),
});

const UpdateCartItemSchema = AddToCartSchema.extend({
    id: z.string(),
});

export type AddToCart = z.infer<typeof AddToCartSchema>;
export type UpdateCart = z.infer<typeof UpdateCartItemSchema>;

// export const ResponseCartListSchema = z.object({
//   id: z.string(),
//   user_id: z.string(),
//   batch_id: z.string(),
//   draft_note: z.string().optional().nullable(),
//   quantity: z.number().positive(),
//   type: z.string(),
//   price: z.number().positive(),
// });
// export type CartList = z.infer<typeof ResponseCartListSchema>;
